import axios from 'axios'
import qs from 'qs'

export default {
  request(url, data = {}, type = 'GET', config = { showLoading: true }) {
    return new Promise(function (resolve, reject) {
      let promise
      if (type === 'GET') {
        let dataStr = ''
        Object.keys(data).forEach(key => {
          dataStr += key + '=' + data[key] + '&'
        })
        if (dataStr !== '') {
          dataStr = dataStr.substring(0, dataStr.lastIndexOf('&'))
          url = url + '?' + dataStr
        }
        promise = axios.get(url, config)
      } else {
        promise = axios.post(url, qs.stringify(data), config)
      }
      promise.then(function (response) {
        resolve(response.data)
      }).catch(function (error) {
        reject(error)
      })
    })
  },
}



// WEBPACK FOOTER //
// ./src/api/ajax.js